<template>
  <body>
    <div>
      <div><HeaderComponent :headerTitle="headerText" /></div>
      <div class="rigt_navbar" id="content">
        <!-- <h3 class="main_header display_non">Import Sku Master File</h3> -->
        <div class="invoic_srch">
          <div class="invoic_srcw pdong_btm">
            <h3 class="sub_header1">Import Sku Master File</h3>

            <form @submit.prevent="importFile" enctype="multipart/form-data">
              <div class="form_group1 text-left">
                <input
                  type="file"
                  class="form-control"
                  ref="file"
                  @change="selectFile"
                  :class="{ 'is-invalid': v$.file.$error }"
                />
                <div v-if="!v$.file.required.$response">
                  <div class="warning_img">
                    <div class="warnig_imgw">
                      <img src="@/assets/images/icons/warning.svg" />File is
                      required
                    </div>
                  </div>
                </div>
              </div>
              <button class="main_button" :disabled="disable">
                Import File
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </body>
</template>

<script>
import HeaderComponent from "../../../commoncomponents/HeaderComponent";
// import { required } from "vuelidate/lib/validators";
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
export default {
  name: "StnDocumentUpload",
  setup () {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      headerText: "Import Sku Master File",
      file: "",
      disable: false,
    };
  },
  components: {
    HeaderComponent,
  },
  validations: {
    file: { required },
  },

  methods: {
    uploadFile: function (ind, eve) {
      this.box_files[ind].consignment_box_file = eve.target.files[0];
    },
    selectFile() {
      this.file = this.$refs.file.files[0];
    },
    importFile() {
      this.v$.file.$touch();
      if (this.v$.file.$invalid) {
        return;
      }
      let formData = new FormData();
      if (this.file.name.split(".").pop() != "csv") {
        this.$toast.error("Only CSV files can be imported");
        return;
      }

      const params = {
        master_file: this.file,
        master_file_type: "Client Sku Master",
        user_id: this.$store.state.currentUser.id,
        client_id: "",
        grading_type: "warehouse",
      };

      this.disable = true;
      Object.entries(params).forEach(([key, value]) =>
        formData.append(key, value),
      );
      this.$httpSecured
        .post("/admin/master_file_uploads", formData)
        .then((response) => {
          this.$router.push("/api/v1/manual_process/sku-master-upload-list");
          this.$toast.success("Successfully uploaded");
        })
        .catch((error) => this.$toast.error("Please Enter Valid File"));
    },
  },
};
</script>
